import React, { useEffect } from "react"

import { graphql } from "gatsby"
import { ArticleKeyFigureRowFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./key-figure-row.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"
import KeyFigure from "./key-figure/key-figure"

type KeyFigureRowProps = {
  data: ArticleKeyFigureRowFieldsFragment
}

const KeyFigureRow: React.FC<KeyFigureRowProps> = ({ data }) => {
  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.transformContainer)[0], 400)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <section className={styles.container}>
      <div className={styles.transformContainer}>
        {data.keyFigureElement.map((keyFigure, index) => {
          return <KeyFigure key={index} data={keyFigure} keyFigureAmount={data.keyFigureElement.length} />
        })}
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment ArticleKeyFigureRowFields on DatoCmsArticleKeyFigureRow {
    __typename
    id
    keyFigureElement {
      ...KeyFigureFields
    }
  }
`

export default KeyFigureRow
